import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import {
  fehHomebatteryStoreSelectorKey,
  reducers,
} from './feh-homebattery.state';
import { HomebatteryAdviceFormEffects } from './effects';
import { HomeBatteryFunnelEffects } from './effects/homebattery-funnel.effects';
import { HomeBatteryWizardEffects } from './effects/homebattery-wizard.effects';

@NgModule({
  imports: [
    StoreModule.forFeature(fehHomebatteryStoreSelectorKey, reducers),
    EffectsModule.forFeature([
      HomeBatteryFunnelEffects,
      HomeBatteryWizardEffects,
      HomebatteryAdviceFormEffects,
    ]),
  ],
})
export class FehHomebatteryStoreModule {}
